import axios__default from 'axios';

var createHttpClient = function (config) {
    return axios__default.create(config);
};

export { createHttpClient };
